import type { FunctionComponent } from 'react';
import { UnstyledButton, Flex, Text } from '@mantine/core';

import { ChevronRightIconSm } from '@chownow/pantry/icons';

type NestedModifierIndicatorProps = {
  variant: 'inline' | 'banner';
  hasNestedGroups: boolean;
  isSelected: boolean;
  nestedSummary?: string;
  onDrillIn: () => void;
};

export const NestedModifierIndicator: FunctionComponent<NestedModifierIndicatorProps> = ({
  variant,
  hasNestedGroups,
  isSelected,
  nestedSummary,
  onDrillIn,
}) => {
  if (!hasNestedGroups) return null;

  if (variant === 'inline') {
    return isSelected ? null : <ChevronRightIconSm aria-hidden />;
  }

  if (!isSelected) return null;

  return (
    <UnstyledButton
      onClick={onDrillIn}
      bg="var(--surface-secondary)"
      w="100%"
      p="sm"
      mt="xs2"
      bdrs="sm"
    >
      <Flex justify="space-between" align="center" gap="xs">
        <Text truncate="end">{nestedSummary}</Text>
        <ChevronRightIconSm aria-hidden />
      </Flex>
    </UnstyledButton>
  );
};
